import { ActionTree } from "vuex";
import { State } from "./state";
import { create, filter, findOne, update, findAll } from "@/store/Crud/functions/actions";

const URL = "/languages";

export default <ActionTree<State, any>>{
  create,
  filter,
  findOne,
  update,
  findAll,
};
